<template>
  <div class="ugo-form-field">
  <FormViewItem v-if="as_view" :label="label" :required="!!required">
    <span class="ugo-form-view-text" :class="{ 'ugo-form-view-empty': isEmptyViewValue(value) }">{{ formatViewText(value) }}</span>
  </FormViewItem>
  <FormItem v-else :label="label" :required="!!required">
    <Input
      type="textarea"
      v-model="_value"
      :disabled="!editable"
       :placeholder="config?.placeholder || '请输入'"
      style="width:100%"
      :rows="_config.rows || 4" />
  </FormItem>
  </div>
</template>

<script>
import defaultValueMixin from '../mixins/default-value';
import valueDefMixin from '../mixins/value-def';
import asViewMixin from '../mixins/as-view';
export default {
  mixins: [defaultValueMixin, valueDefMixin, asViewMixin],
  methods: {
    getValueDef() {
      return this.valueDefString();
    },
  },
  cname: '长文本输入',
  corder: 20,
  icon: 'changwenbenxiangsi',
  props: ['value', 'label', 'required', 'config', 'editable'],
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    _config() {
      return this.config || {};
    },
  },
  initModel(e) {
    if (!e.config) {
      e.config = {
        options: [],
        simple: true,
      };
    } else {
      e.config = {
        options: e.config.options || [],
        simple: true,
      };
    }
  },
  properties: [
    {
      label: '字数限制',
      key: 'maxlen',
      control: 'Text',
    },
    {
      label: '宽度',
      key: 'width',
      control: 'Text',
    },
    {
      label: '行数',
      key: 'rows',
      control: 'Text',
      option: {
        number: true,
      },
    },
    {
      label: '提示文字',
      key: 'placeholder',
      control: 'Text',
    },
    {
    label: '预设输入',
    key: 'options',
    control: 'SelectOption',
  }, {
    label: '简易选项',
    key: 'simple',
    control: 'Check',
  },

  ],
};
</script>

<style lang="less" scoped>

</style>
